import { NgModule } from '@angular/core';
import { AbsenceEmployeeStatusPipe } from './absence-employee-status/absence-employee-status.pipe';
import { AbsenceUnitPipe } from './absence-unit/absence-unit.pipe';
import { AssessmentEmployeeStatusPipe } from './assessment-employee-status/assessment-employee-status.pipe';
import { AssessmentStatusPipe } from './assessment-status/assessment-status.pipe';
import { BooleanPipe } from './boolean/boolean.pipe';
import { CalendarStatusPipe } from './calendar-status-name/calendar-status.pipe';
import { CheckCategoryNamePipe } from './check-category/check-category-name.pipe';
import { CheckRequestsStatusNamePipe } from './check-requests-status-name/check-requests-status-name.pipe';
import { CheckRequestsTypeNamePipe } from './check-requests-type-name/check-requests-type-name.pipe';
import { ChecksActionsNamePipe } from './checks-actions/checks-actions-name.pipe';
import { ChecksTypeNamePipe } from './checks-type/checks-type-name.pipe';
import { CompanyModulesNamePipe } from './company-modules-name/company-modules-name.pipe';
import { DayInfoPipe } from './date/day-info.pipe';
import { TotalMinutesFormatPipe } from './date/total-minutes-format.pipe';
import { EmployeeAbsenceStatusPipe } from './employee/employee-absence-status.pipe';
import { EmployeeAbsenceTimePipe } from './employee/employee-absence-time.pipe';
import { EmployeeContractTerminationTypePipe } from './employee/employee-contract-termination-type.pipe';
import { EmployeeContractPipe } from './employee/employee-contract.pipe';
import { EmployeeDisabilityDegreePipe } from './employee/employee-disability-degree.pipe';
import { EmployeeDisableTypePipe } from './employee/employee-disable-type.pipe';
import { EmployeeDocumentTypePipe } from './employee/employee-document-type.pipe';
import { EmployeeEducationPipe } from './employee/employee-education.pipe';
import { EmployeeGenderPipe } from './employee/employee-gender.pipe';
import { EmployeeHistoryPipe } from './employee/employee-history.pipe';
import { EmployeeJourneyScalePipe } from './employee/employee-journey-scale.pipe';
import { EmployeeProfilePipe } from './employee/employee-profile.pipe';
import { EmployeeShiftStatusSelectorPipe } from './employee/employee-shift-status-selector.pipe';
import { EmployeeStatusSelectorPipe } from './employee/employee-status-selector.pipe';
import { EmployeeStatusPipe } from './employee/employee-status.pipe';
import { EmployeeTypeCheckPipe } from './employee/employee-type-check.pipe';
import { SelectorEmployeeStatusPipe } from './employee/selector-employee-status.pipe';
import { ShiftStatusPipe } from './employee/shift-status.pipe';
import { EnumInfoPipe } from './enum-info/enum-info.pipe';
import { FileNameTruncatePipe } from './file-name-truncate/file-name-truncate.pipe';
import { FileSizePipe } from './file-size/file-size.pipe';
import { HolidayTypePipe } from './holidays-type/holiday-type.pipe';
import { PaymentMethodInfoPipe } from './payments/payment-method-info.pipe';
import { PaymentMethodSymbolPipe } from './payments/payment-method-symbol.pipe';
import { PermitsValidatePipe } from './permits-validate/permits-validate.pipe';
import { ProjectsStatusPipe } from './project-status/projects-status.pipe';
import { ScheduleTypePipe } from './schedule-type/schedule-type.pipe';
import { TasksStatusPipe } from './task-status/tasks-status.pipe';
import { TasksUnassignedPipe } from './tasks-unassigned/tasks-unassigned.pipe';
import { TicketPriorityPipe } from './ticket/ticket-priority.pipe';
import { TicketStatusPipe } from './ticket/ticket-status.pipe';
import { TicketTypePipe } from './ticket/ticket-type.pipe';
import { TypeFilesIconsPipe } from './ticket/type-files-icons.pipe';
import { TimeAgoPipe } from './time-ago/time-ago.pipe';
import { TimeBankTypeNamePipe } from './time-bank-name/bag-hours-name.pipe';
import { TotalHoursPerDayPipe } from './time/total-hours-per-day.pipe';
import { TotalHoursPerWeekPipe } from './time/total-hours-per-week.pipe';
import { TotalHoursSinglePipe } from './time/total-hours-single.pipe';
import { TimezoneFilterPipe } from './timezone/timezone-filter.pipe';
import { UserRoleHintPipe } from './user/user-role-hint.pipe';
import { UserRolePipe } from './user/user-role.pipe';
import { UserStatusPipe } from './user/user-status.pipe';

const pipes = [
  AbsenceEmployeeStatusPipe,
  AbsenceUnitPipe,
  AssessmentEmployeeStatusPipe,
  AssessmentStatusPipe,
  BooleanPipe,
  CalendarStatusPipe,
  CheckCategoryNamePipe,
  CheckRequestsStatusNamePipe,
  CheckRequestsTypeNamePipe,
  ChecksActionsNamePipe,
  ChecksTypeNamePipe,
  CompanyModulesNamePipe,
  DayInfoPipe,
  EmployeeAbsenceStatusPipe,
  EmployeeAbsenceTimePipe,
  EmployeeContractPipe,
  EmployeeContractTerminationTypePipe,
  EmployeeDisabilityDegreePipe,
  EmployeeDisableTypePipe,
  EmployeeDocumentTypePipe,
  EmployeeEducationPipe,
  EmployeeGenderPipe,
  EmployeeHistoryPipe,
  EmployeeJourneyScalePipe,
  EmployeeProfilePipe,
  EmployeeShiftStatusSelectorPipe,
  EmployeeStatusPipe,
  EmployeeStatusSelectorPipe,
  EmployeeTypeCheckPipe,
  EnumInfoPipe,
  FileNameTruncatePipe,
  FileSizePipe,
  HolidayTypePipe,
  PaymentMethodInfoPipe,
  PaymentMethodSymbolPipe,
  PermitsValidatePipe,
  ProjectsStatusPipe,
  ScheduleTypePipe,
  SelectorEmployeeStatusPipe,
  ShiftStatusPipe,
  TasksStatusPipe,
  TasksUnassignedPipe,
  TicketPriorityPipe,
  TicketStatusPipe,
  TicketTypePipe,
  TimeAgoPipe,
  TimeBankTypeNamePipe,
  TimezoneFilterPipe,
  TotalHoursPerDayPipe,
  TotalHoursPerWeekPipe,
  TotalHoursSinglePipe,
  TotalMinutesFormatPipe,
  TypeFilesIconsPipe,
  UserRoleHintPipe,
  UserRolePipe,
  UserStatusPipe,
];

@NgModule({
  declarations: [pipes],
  exports: [pipes],
})
export class PipesModule {}
